import { FC, useEffect, useState } from "react";
import {
  SignIn,
  StaffManagement,
  AllRecipes,
  Ingredients,
  Units,
  Categories,
  Tags,
  CreateRecipe,
  EditRecipe,
  Users,
  UserProfile,
  Reports,
  FAQ,
  EditFaqPage,
  CalorieDeficitData,
  UsersCoach,
} from "../pages";
import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import Feedback from "../pages/Dashboard/Feedback";
import { getUser } from "../utils/tokenStorage";

const Navigation: FC = () => {
  const [me, setMe] = useState(getUser());

  useEffect(() => {
    function storageEventHandler(event: any) {
      setMe(getUser());
    }

    window.addEventListener("storage", storageEventHandler);

    return () => {
      window.removeEventListener("storage", storageEventHandler);
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="signIn" element={<SignIn />} />
        <Route path="/*" element={<PrivateRoute />}>
          <Route path="staff-management" element={<StaffManagement />} />
          <Route path="all-recipes" element={<AllRecipes />} />
          <Route path="create-recipe" element={<CreateRecipe />} />
          <Route path="edit-recipe/:id" element={<EditRecipe />} />
          <Route path="ingredients" element={<Ingredients />} />
          <Route path="units" element={<Units />} />
          <Route path="categories" element={<Categories />} />
          <Route path="tags" element={<Tags />} />
          <Route path="users" element={<UsersCoach />} />
          <Route path="users" element={<UsersCoach />} />
          <Route path="feedback" element={<Feedback />} />

          <Route path="users/:id" element={<UserProfile />} />
          <Route path="reports" element={<Reports />} />
          <Route path="faq" element={<FAQ />} />
          <Route path="faq/:id" element={<EditFaqPage />} />
          <Route
            path="calorie-deficit-data/:id"
            element={<CalorieDeficitData />}
          />

          <Route path="*" element={<Navigate to="/users" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Navigation;
